import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import ApiDocs from './pages/ApiDocs';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import MarketingLayout from './marketing/MarketingLayout';
import Home from './marketing/Home';
import Products from './marketing/Products';
import ProductCategory from './marketing/ProductCategory';
import PricingPage from './marketing/PricingPage';
import Results from './marketing/Results';
import FreeToolsPage from './marketing/FreeToolsPage';
import FreeToolPage from './marketing/FreeToolPage';
import About from './marketing/About';
import DashboardLayout from './pages/DashboardLayout';
import Overview from './pages/dashboard/Overview';
import VisibilityPage from './pages/dashboard/VisibilityPage';
import RankPage from './pages/dashboard/RankPage';
import LeadsPage from './pages/dashboard/LeadsPage';
import AIStudioPage from './pages/dashboard/AIStudioPage';
import AIToolPage from './pages/dashboard/AIToolPage';
import OperationsPage from './pages/dashboard/OperationsPage';
import SetupPage from './pages/dashboard/SetupPage';
import AdminPage from './pages/dashboard/AdminPage';
import { AuthProvider, useAuth } from './context/AuthContext';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="auth-loading"><span className="auth-spinner" style={{ borderTopColor: '#1f46c9', borderColor: 'rgba(31,70,201,0.2)' }} /></div>;
  return user ? children : <Navigate to="/login" replace />;
}

export default function Root() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route element={<MarketingLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:slug" element={<ProductCategory />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/results" element={<Results />} />
            <Route path="/free-tools" element={<FreeToolsPage />} />
            <Route path="/free-tools/:slug" element={<FreeToolPage />} />
            <Route path="/about" element={<About />} />
          </Route>

          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
            <Route index element={<Overview />} />
            <Route path="visibility" element={<VisibilityPage />} />
            <Route path="rank" element={<RankPage />} />
            <Route path="leads" element={<LeadsPage />} />
            <Route path="ai-studio" element={<AIStudioPage />} />
            <Route path="ai-studio/:toolId" element={<AIToolPage />} />
            <Route path="operations" element={<OperationsPage />} />
            <Route path="setup" element={<SetupPage />} />
            <Route path="admin" element={<AdminPage />} />
          </Route>

          <Route path="/docs/datatallied-api" element={<ApiDocs />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
